import { PanelHybrid } from "./PanelHybrid";
import { PanelHeader } from "./PanelHeader";
import { PanelContent } from "./PanelContent";
import { PanelCloseButton } from "./PanelCloseButton";
import { PanelFooter } from "./PanelFooter";
import type { TypePanelProps } from "./PanelTypes";

/**
 * Panel compound component. Automatically routes between the Tailwind
 * implementation (preferred, no runtime CSS-in-JS) and the styled-components
 * implementation (for consumers using styled-system props or a `styled()`
 * extension). Public API, exports, and the `.Header/.Content/.CloseButton/
 * .Footer` static attachments are unchanged.
 */
const PanelComponent = (props: TypePanelProps) => <PanelHybrid {...props} />;

PanelComponent.displayName = "Panel";
PanelComponent.Header = PanelHeader;
PanelComponent.Content = PanelContent;
PanelComponent.CloseButton = PanelCloseButton;
PanelComponent.Footer = PanelFooter;

export const Panel = PanelComponent;
export default PanelComponent;
